import { createComputerAutomationEnvironmentAtoms } from "@praxa/client-runtime/state/computer-automation";

import { connectionAtomRuntime } from "../connection/runtime";

export const computerAutomationEnvironment =
  createComputerAutomationEnvironmentAtoms(connectionAtomRuntime);
